import { render, staticRenderFns } from "./RunningItem.vue?vue&type=template&id=e8063e60&scoped=true&"
import script from "./RunningItem.vue?vue&type=script&lang=ts&"
export * from "./RunningItem.vue?vue&type=script&lang=ts&"
import style0 from "./RunningItem.vue?vue&type=style&index=0&id=e8063e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8063e60",
  null
  
)

export default component.exports